import React from 'react';
import {
  createStyles,
  withStyles,
  colors,
  Button,
  Grid,
  Theme,
  Typography,
} from '@material-ui/core';
import Language from '@material-ui/icons/Language';
import i18next from 'i18next';

const styles = (theme: Theme) =>
  createStyles({
    languageItem: {
      marginLeft: theme.spacing(2),
      fontSize  : 14,
    },
    activeLanguage: {
      fontWeight    : 500,
      textDecoration: 'underline',
      marginLeft    : 0,
    },
    icon: {
      fontSize   : 18,
      color      : colors.grey[800],
      marginRight: theme.spacing(.5),
    },
    footerLanguageWrapper: {
      marginBottom : theme.spacing(2),
      paddingBottom: theme.spacing(2),
      borderBottom : `1px solid ${colors.grey[300]}`,
    },
  });

const languageMap = {
  'en-US': 'English',
  'es-US': 'Español',
};

/**
 * Takes in a language code and returns the display name
 *
 * @param {string} language 'en' | 'es'
 * @returns {string}
 */
const getLanguageDisplayName = (language: string): string => {
  return languageMap[language] || languageMap['en-US'];
};

const LanguageSelectorComponent = ({ ...props }) => {
  const { classes, footerSelector } = props;
  const activeLanguage = i18next.language;
  const handleClick = (key) => {
    i18next.changeLanguage(key);
  };

  const renderLanguageLinks = () => {
    return Object.entries(languageMap).map(([key, value]) => {
      if (key !== activeLanguage) {
        return (
          <Grid item key={`${key}-${value}`} className={classes.languageItem}>
            <Button
              onClick            = {() => handleClick(key)}
              disableRipple      = {true}
              disableFocusRipple = {true}
              classes            = {{ root: 'smallTextButton' }}
            >
              {value}
            </Button>
          </Grid>
        );
      } else {
        return null;
      }
    });
  };

  return (
    <Grid
      container
      justifyContent    = "center"
      alignItems = "center"
      className  = {footerSelector && classes.footerLanguageWrapper}
    >
      <Grid item>
        <Language className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography className={`${classes.languageItem} ${classes.activeLanguage}`}>
          {getLanguageDisplayName(activeLanguage)}
        </Typography>
      </Grid>
      {renderLanguageLinks()}
    </Grid>
  );
};

export const LanguageSelector: any = withStyles(styles)(LanguageSelectorComponent);
